'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeProvider = require('@spp/theme-provider');

var _TopObject = require('./TopObject');

var _TopObject2 = _interopRequireDefault(_TopObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// noinspection JSUnresolvedVariable
exports.default = (0, _themeProvider.themer)('@vg/top-object')(_TopObject2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/top-object/lib/cjs/index.js
 ** module id = 745
 ** module chunks = 1
 **/